import React from "react";
import styles from "../../../src/styles/Blog/Tags.module.css";

const SearchTags = ({ tags, selectedCategory, setSelectedCategory }) => {
  function handleCategoryClick(tag) {
    console.log("function Handle Category Clicked", tag);
    setSelectedCategory(tag);
  }
  return (
    <div className={styles.tagsContainer}>
      {tags.map((tag, index) => (
        <div
          key={index}
          className={`${styles.tag} ${
            tag === selectedCategory ? styles.selected : ""
          }`}
          onClick={() => handleCategoryClick(tag)}
        >
          <span>{tag}</span>
        </div>
      ))}
    </div>
  );
};

export default SearchTags;
